import React from 'react';

import Button from '../../../../../components/common/button/button';
import Icon, { IconNames } from '../../../../../components/common/icon/icon';
import Tooltip from '../../../../../components/common/tooltip/tooltip';

interface Props {
  onClick?(): void;
  icon: IconNames;
  hint?: string;
}

export const ActionButton: React.FunctionComponent<Props> = ({
  onClick,
  icon,
  hint,
}: Props) => (
  <Tooltip content={hint} theme="dark" placement="left">
    <span>
      <Button
        dataHook="operation-status-actions-button"
        height="x-small"
        theme="icon-white"
        onClick={onClick}
      >
        <Icon name={icon} fontSize={16} />
      </Button>
    </span>
  </Tooltip>
);
